import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar } = FiIcons;

const reviews = [
  {
    name: "Sarah Jenkins",
    text: "SwitchFree funded my $500 Verizon buyout in minutes. I kept my number and now I pay $15/mo. The savings practically pay for the loan itself.",
    amount: "$500 Funded",
    initial: "S"
  },
  {
    name: "Michael Chen",
    text: "I was stuck in a 3-year contract. I used the trade-in path and my device debt was settled the same day. The process was incredibly transparent.",
    amount: "$850 Settled",
    initial: "M"
  },
  {
    name: "Elena Rodriguez",
    text: "The process was so smooth. Zero hidden fees. The flexible financing options were exactly what I needed to break free from AT&T without a huge upfront cost.",
    amount: "$420 Funded",
    initial: "E"
  }
];

export default function Testimonials() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-3xl font-extrabold text-slate-900">What our members say</h2>
        <p className="mt-4 text-lg text-slate-600">Real people, real savings, real freedom.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {reviews.map((review, idx) => (
          <div key={idx} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow flex flex-col">
            <div className="flex text-yellow-400 mb-4">
              {[...Array(5)].map((_, i) => (
                <SafeIcon key={i} icon={FiStar} className="w-5 h-5 fill-current" />
              ))}
            </div>
            <p className="text-slate-600 mb-8 leading-relaxed italic">"{review.text}"</p>
            <div className="flex items-center justify-between mt-auto pt-6 border-t border-slate-50">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold">
                  {review.initial}
                </div>
                <span className="font-semibold text-slate-900">{review.name}</span>
              </div>
              <span className="text-sm font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                {review.amount}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}